export const currencies = [
  { code: 'AFN', name: 'Afghan Afghani' },
  { code: 'ALL', name: 'Albanian Lek' },
  { code: 'DZD', name: 'Algerian Dinar' },
  { code: 'EUR', name: 'Euro' },
  { code: 'AOA', name: 'Angolan Kwanza' },
  { code: 'XCD', name: 'East Caribbean Dollar' },
  { code: 'ARS', name: 'Argentine Peso' },
  { code: 'AMD', name: 'Armenian Dram' },
  { code: 'AUD', name: 'Australian Dollar' },
  { code: 'AZN', name: 'Azerbaijani Manat' },
  { code: 'BSD', name: 'Bahamian Dollar' },
  { code: 'BHD', name: 'Bahraini Dinar' },
  { code: 'BDT', name: 'Bangladeshi Taka' },
  { code: 'BBD', name: 'Barbadian Dollar' },
  { code: 'BYN', name: 'Belarusian Ruble' },
  { code: 'BZD', name: 'Belize Dollar' },
  { code: 'XOF', name: 'West African CFA Franc' },
  { code: 'BTN', name: 'Bhutanese Ngultrum' },
  { code: 'BOB', name: 'Boliviano' },
  { code: 'BAM', name: 'Convertible Mark' },
  { code: 'BWP', name: 'Botswana Pula' },
  { code: 'BRL', name: 'Brazilian Real' },
  { code: 'BND', name: 'Brunei Dollar' },
  { code: 'BGN', name: 'Bulgarian Lev' },
  { code: 'XAF', name: 'Central African CFA Franc' },
  { code: 'BIF', name: 'Burundian Franc' },
  { code: 'KHR', name: 'Cambodian Riel' },
  { code: 'CAD', name: 'Canadian Dollar' },
  { code: 'CVE', name: 'Cape Verdean Escudo' },
  { code: 'CLP', name: 'Chilean Peso' },
  { code: 'CNY', name: 'Chinese Yuan Renminbi' },
  { code: 'COP', name: 'Colombian Peso' },
  { code: 'KMF', name: 'Comorian Franc' },
  { code: 'CRC', name: 'Costa Rican Colón' },
  { code: 'CUP', name: 'Cuban Peso' },
  { code: 'CZK', name: 'Czech Koruna' },
  { code: 'DKK', name: 'Danish Krone' },
  { code: 'DJF', name: 'Djiboutian Franc' },
  { code: 'DOP', name: 'Dominican Peso' },
  { code: 'USD', name: 'United States Dollar' },
  { code: 'EGP', name: 'Egyptian Pound' },
  { code: 'ERN', name: 'Eritrean Nakfa' },
  { code: 'ETB', name: 'Ethiopian Birr' },
  { code: 'FJD', name: 'Fijian Dollar' },
  { code: 'FJD', name: 'Fijian Dollar' },
  { code: 'GMD', name: 'Gambian Dalasi' },
  { code: 'GEL', name: 'Georgian Lari' },
  { code: 'GHS', name: 'Ghanaian Cedi' },
  { code: 'GTQ', name: 'Guatemalan Quetzal' },
  { code: 'GNF', name: 'Guinean Franc' },
  { code: 'GYD', name: 'Guyanese Dollar' },
  { code: 'HTG', name: 'Haitian Gourde' },
  { code: 'HNL', name: 'Honduran Lempira' },
  { code: 'HUF', name: 'Hungarian Forint' },
  { code: 'ISK', name: 'Icelandic Krona' },
  { code: 'INR', name: 'Indian Rupee' },
  { code: 'IDR', name: 'Indonesian Rupiah' },
  { code: 'IRR', name: 'Iranian Rial' },
  { code: 'IQD', name: 'Iraqi Dinar' },
  { code: 'ILS', name: 'Israeli New Shekel' },
  { code: 'JPY', name: 'Japanese Yen' },
  { code: 'JOD', name: 'Jordanian Dinar' },
  { code: 'KZT', name: 'Kazakhstani Tenge' },
  { code: 'KES', name: 'Kenyan Shilling' },
  { code: 'KWD', name: 'Kuwaiti Dinar' },
  { code: 'KGS', name: 'Kyrgyzstani Som' },
  { code: 'LAK', name: 'Lao Kip' },
  { code: 'LBP', name: 'Lebanese Pound' },
  { code: 'LSL', name: 'Lesotho Loti' },
  { code: 'LRD', name: 'Liberian Dollar' },
  { code: 'LYD', name: 'Libyan Dinar' },
  { code: 'MGA', name: 'Malagasy Ariary' },
  { code: 'MWK', name: 'Malawian Kwacha' },
  { code: 'MYR', name: 'Malaysian Ringgit' },
  { code: 'MVR', name: 'Maldivian Rufiyaa' },
  { code: 'MRU', name: 'Mauritanian Ouguiya' },
  { code: 'MUR', name: 'Mauritian Rupee' },
  { code: 'MXN', name: 'Mexican Peso' },
  { code: 'MDL', name: 'Moldovan Leu' },
  { code: 'MNT', name: 'Mongolian Tögrög' },
  { code: 'MAD', name: 'Moroccan Dirham' },
  { code: 'MZN', name: 'Mozambican Metical' },
  { code: 'MMK', name: 'Burmese Kyat' },
  { code: 'NAD', name: 'Namibian Dollar' },
  { code: 'NPR', name: 'Nepalese Rupee' },
  { code: 'NZD', name: 'New Zealand Dollar' },
  { code: 'NIO', name: 'Nicaraguan Córdoba' },
  { code: 'NGN', name: 'Nigerian Naira' },
  { code: 'MKD', name: 'Macedonian Denar' },
  { code: 'NOK', name: 'Norwegian Krone' },
  { code: 'OMR', name: 'Omani Rial' },
  { code: 'PKR', name: 'Pakistani Rupee' },
  { code: 'PAB', name: 'Panamanian Balboa' },
  { code: 'PGK', name: 'Papua New Guinean Kina' },
  { code: 'PYG', name: 'Paraguayan Guaraní' },
  { code: 'PEN', name: 'Peruvian Sol' },
  { code: 'PHP', name: 'Philippine Peso' },
  { code: 'PLN', name: 'Polish Złoty' },
  { code: 'QAR', name: 'Qatari Riyal' },
  { code: 'RON', name: 'Romanian Leu' },
  { code: 'RUB', name: 'Russian Ruble' },
  { code: 'RWF', name: 'Rwandan Franc' },
  { code: 'SBD', name: 'Solomon Islands Dollar' },
  { code: 'WST', name: 'Samoan Tālā' },
  { code: 'STN', name: 'São Toméan Dobra' },
  { code: 'SAR', name: 'Saudi Riyal' },
  { code: 'SCR', name: 'Seychellois Rupee' },
  { code: 'SLL', name: 'Sierra Leonean Leone' },
  { code: 'SGD', name: 'Singapore Dollar' },
  { code: 'SOS', name: 'Somali Shilling' },
  { code: 'ZAR', name: 'South African Rand' },
  { code: 'SSP', name: 'South Sudanese Pound' },
  { code: 'LKR', name: 'Sri Lankan Rupee' },
  { code: 'SDG', name: 'Sudanese Pound' },
  { code: 'SRD', name: 'Surinamese Dollar' },
  { code: 'SEK', name: 'Swedish Krona' },
  { code: 'CHF', name: 'Swiss Franc' },
  { code: 'SYP', name: 'Syrian Pound' },
  { code: 'TWD', name: 'New Taiwan Dollar' },
  { code: 'TJS', name: 'Tajikistani Somoni' },
  { code: 'TZS', name: 'Tanzanian Shilling' },
  { code: 'THB', name: 'Thai Baht' },
  { code: 'TOP', name: 'Tongan Paʻanga' },
  { code: 'TTD', name: 'Trinidad & Tobago Dollar' },
  { code: 'TND', name: 'Tunisian Dinar' },
  { code: 'TRY', name: 'Turkish Lira' },
  { code: 'TMT', name: 'Turkmenistan Manat' },
  { code: 'UGX', name: 'Ugandan Shilling' },
  { code: 'UAH', name: 'Ukrainian Hryvnia' },
  { code: 'AED', name: 'UAE Dirham' },
  { code: 'GBP', name: 'Pound Sterling' },
  { code: 'UYU', name: 'Uruguayan Peso' },
  { code: 'UZS', name: 'Uzbekistani Som' },
  { code: 'VES', name: 'Venezuelan Bolívar' },
  { code: 'VND', name: 'Vietnamese Đồng' },
  { code: 'YER', name: 'Yemeni Rial' },
  { code: 'ZMW', name: 'Zambian Kwacha' },
  { code: 'ZWL', name: 'Zimbabwe Dollar' }
]
export default currencies
